import { useEffect } from 'react'

import {
  SmsConsentStatusOption,
  fetchSmsConsentStatus,
  getSmsConsentStatus,
} from '../../../account-details-card/sms-consent/smsConsentReducer'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'

import { OptedIn } from '../../../account-details-card/sms-consent/OptedIn'
import { OptedOut } from './OptedOut'

export const SmsConsent = () => {
  const dispatch = useAppDispatch()
  const smsConsentStatus = useReselector(getSmsConsentStatus)

  useEffect(() => {
    dispatch(fetchSmsConsentStatus())
  }, [dispatch])

  const isOptedIntoSms =
    smsConsentStatus?.status === SmsConsentStatusOption.OPT_IN

  return (
    <div className="flex flex-col gap-4">
      {isOptedIntoSms && smsConsentStatus ? (
        <OptedIn
          createdAt={smsConsentStatus.createdAt}
          mobilePhoneNumber={smsConsentStatus.mobilePhoneNumber}
        />
      ) : (
        <OptedOut />
      )}
    </div>
  )
}
